import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CaseStudiesSection = () => {
  const industries = [
    {
      name: 'E-commerce',
      icon: 'ShoppingBag',
      description: 'Store sync, abandoned cart recovery, and order updates across Shopify, WhatsApp, and email.',
    },
    {
      name: 'Real Estate',
      icon: 'Building2',
      description: 'Lead capture, instant follow-ups, and viewing scheduling that keeps agents on closings, not admin.',
    },
    {
      name: 'Healthcare',
      icon: 'HeartPulse',
      description: 'Appointment reminders, intake forms, and patient communication handled securely and on time.',
    },
    {
      name: 'SaaS',
      icon: 'Cloud',
      description: 'Onboarding flows, support automation, and CRM sync that scale with your user base.',
    },
    {
      name: 'Agencies & Consultants',
      icon: 'Briefcase',
      description: 'Client onboarding, reporting, and lead nurturing that free up billable hours.',
    },
    {
      name: 'Local Services',
      icon: 'MapPin',
      description: 'Bookings, reminders, and reviews that keep your calendar full and your reputation strong.',
    },
  ];

  return (
    <section className="bg-surface py-20 lg:py-28">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="space-y-4 max-w-2xl">
            <div className="inline-flex items-center space-x-2 px-3 py-1 bg-accent/10 rounded-full">
              <Icon name="Award" size={16} className="text-accent" />
              <span className="text-sm font-semibold text-accent uppercase tracking-wide">Who We Help</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-text-primary leading-tight">
              Automation Systems <br /><span className="text-primary">Built For Your Industry</span>
            </h2>
            <p className="text-text-secondary leading-relaxed">
              Every industry has its own repetitive work. These are the sectors where our workflows
              and marketing systems make the biggest difference.
            </p>
          </div>

          <Link to="/industry-solutions" className="hidden md:block">
            <Button variant="outline" iconName="ArrowRight" iconPosition="right">
              Explore Industries
            </Button>
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry) => (
            <Link key={industry.name} to="/industry-solutions" className="group">
              <div className="h-full bg-card rounded-2xl border border-border p-6 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary transition-colors duration-300">
                  <Icon name={industry.icon} size={24} className="text-primary group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-text-primary mb-2 group-hover:text-primary transition-colors">
                  {industry.name}
                </h3>
                <p className="text-text-secondary text-sm leading-relaxed">{industry.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
